module.exports = __webpack_public_path__ + "img/14.3a66a764.png";